module.exports = __webpack_public_path__ + "static/media/path_puplisher.8b4826e3.svg";